import { Checkbox } from "../../../../../components/ui/checkbox"
import { Card } from "../../../../../components/ui/card"
import { Building2, Package } from "lucide-react"

import { useSchoolsStore } from "../../../../../context/useSchoolsStore"
import { useModulesStore } from "../../../../../context/useModulesStore"

// // Mock data
// const SCHOOLS = [
//   {
//     id: "school-1",
//     name: "Lincoln High School",
//     modules: [
//       { id: "mod-1", name: "English Literature" },
//       { id: "mod-2", name: "Mathematics" },
//       { id: "mod-3", name: "Science" },
//     ],
//   },
//   {
//     id: "school-2",
//     name: "Washington Academy",
//     modules: [
//       { id: "mod-4", name: "History" },
//       { id: "mod-5", name: "Art & Design" },
//       { id: "mod-6", name: "Physical Education" },
//     ],
//   },
// ]

export function SchoolModuleStep({ rights, updateRights }) {

  const { schools, isSchoolLoading } = useSchoolsStore();
  const { modules, isModulesLoading } = useModulesStore();

  if (isSchoolLoading || isModulesLoading) {
    return <div className="text-muted-foreground">Loading schools and modules...</div>
  }

  // const handleSchoolToggle = (schoolId) => {
  //   const school = schools.find((s) => s.id === schoolId)
  //   if (!school) return

  //   if (rights.schools_id.includes(schoolId)) {
  //     // Deselect school and all its modules
  //     updateRights({
  //       schools_id: rights.schools_id.filter((id) => id !== schoolId),
  //       module_ids: rights.module_ids.filter((modId) => !school.modules.some((m) => m.id === modId)),
  //     })
  //   } else {
  //     // Select school and all its modules
  //     updateRights({
  //       schools_id: [...rights.schools_id, schoolId],
  //       module_ids: [...rights.module_ids, ...school.modules.map((m) => m.id)],
  //     })
  //   }
  // }

 

  // const handleModuleToggle = (moduleId) => {
  //   const isSelected = rights.module_ids.includes(moduleId)
  //   const newModuleIds = isSelected
  //     ? rights.module_ids.filter((id) => id !== moduleId)
  //     : [...rights.module_ids, moduleId]

  //   updateRights({ module_ids: newModuleIds })

  //   // Update school selection based on module selections
  //   const updatedSchools = SCHOOLS.filter((school) => {
  //     const schoolModules = school.modules.map((m) => m.id)
  //     return schoolModules.some((modId) => newModuleIds.includes(modId))
  //   }).map((s) => s.id)

  //   updateRights({ schools_id: updatedSchools })
  // }

  const handleSchoolToggle = (schoolId) => {
    const school = schools.find((s) => s.id === schoolId)
    if (!school) return

    const isSelected = rights.schools.create.includes(schoolId) || rights.schools.read.includes(schoolId)

    if (isSelected) {
      updateRights({
        schools: {
          create: rights.schools.create.filter((id) => id !== schoolId),
          read: rights.schools.read.filter((id) => id !== schoolId),
          update: rights.schools.update.filter((id) => id !== schoolId),
          delete: rights.schools.delete.filter((id) => id !== schoolId),
        },
        modules: {
          create: rights.modules.create.filter((modKey) => !modKey.startsWith(`${schoolId}_`)),
          read: rights.modules.read.filter((modKey) => !modKey.startsWith(`${schoolId}_`)),
          update: rights.modules.update.filter((modKey) => !modKey.startsWith(`${schoolId}_`)),
          delete: rights.modules.delete.filter((modKey) => !modKey.startsWith(`${schoolId}_`)),
        },
      })
    } else {
      updateRights({
        schools: {
          create: [...rights.schools.create, schoolId],
          read: rights.schools.read,
          update: rights.schools.update,
          delete: rights.schools.delete,
        },
        modules: {
          create: [...rights.modules.create, ...(school.moduleIds || []).map((modId) => `${schoolId}_${modId}`)],
          read: rights.modules.read,
          update: rights.modules.update,
          delete: rights.modules.delete,
        },
      })
    }
  }

  const handleModuleToggle = (schoolId, moduleId) => {
    // const compositeKey = `${schoolId}_${moduleId}`
    const compositeKey = `${moduleId}`
    const isSelected = rights.modules.create.includes(compositeKey) || rights.modules.read.includes(compositeKey)

    updateRights({
      modules: isSelected
        ? {
            create: rights.modules.create.filter((id) => id !== compositeKey),
            read: rights.modules.read.filter((id) => id !== compositeKey),
            update: rights.modules.update.filter((id) => id !== compositeKey),
            delete: rights.modules.delete.filter((id) => id !== compositeKey),
          }
        : {
            create: [...rights.modules.create, compositeKey],
            read: rights.modules.read,
            update: rights.modules.update,
            delete: rights.modules.delete,
          },
    })
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Building2 className="w-5 h-5" />
          Select Schools & Modules
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Choose which schools and their modules this user can access
        </p>
      </div>

      {schools.map((school) => {
        // const isSchoolSelected = rights.schools_id.includes(school.id)
        // const selectedModuleCount = school.modules.filter((m) => rights.module_ids.includes(m.id)).length

        const isSchoolSelected = rights.schools.create.includes(school.id) || rights.schools.read.includes(school.id)
        const selectedModuleCount = (school.moduleIds || []).filter((m) => {
          // const compositeKey = `${school.id}_${m}`
          const compositeKey = `${m}`
          return rights.modules.create.includes(compositeKey) || rights.modules.read.includes(compositeKey)
        }).length

        return (
          <Card
            key={school.id}
            className="p-4 border border-border bg-background hover:border-primary/50 transition-colors cursor-pointer"
          >
            {/* School Header */}
            <div className="flex items-start gap-3">
              <Checkbox
                checked={isSchoolSelected}
                onCheckedChange={() => handleSchoolToggle(school.id)}
                className="mt-1"
              />
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <Building2 className="w-4 h-4 text-primary" />
                  <h4 className="font-semibold text-foreground">{school.name}</h4>
                  {selectedModuleCount > 0 && (
                    <span className="text-xs bg-primary text-primary-foreground px-2 py-1 rounded-full">
                      {selectedModuleCount}/{school.moduleIds?.length || 0}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Modules */}
            <div className="mt-4 ml-9 space-y-3">
              {modules.map((module) => {
                // const isModuleSelected = rights.module_ids.includes(module.id)
                // const compositeKey = `${school.id}_${module?.id}`
                const compositeKey = `${module?.id}`
                const isModuleSelected =
                  rights.modules.create.includes(compositeKey) || rights.modules.read.includes(compositeKey)
                return (
                  <label
                    key={module.id}
                    className="flex items-center gap-3 p-3 rounded-md bg-muted/30 hover:bg-muted/60 transition-colors cursor-pointer"
                  >
                    <Checkbox checked={isModuleSelected} onCheckedChange={() => handleModuleToggle(school.id,module.id)} />
                    <Package className="w-4 h-4 text-muted-foreground" />
                    <span className="text-sm text-foreground">{module.name}</span>
                  </label>
                )
              })}
            </div>
          </Card>
        )
      })}
    </div>
  )
}
